export default "__VITE_ASSET__BaP7o2Fp__"